import { render, staticRenderFns } from "./DishesManagement.vue?vue&type=template&id=d0369a9e&scoped=true"
import script from "./DishesManagement.vue?vue&type=script&lang=ts"
export * from "./DishesManagement.vue?vue&type=script&lang=ts"
import style0 from "./DishesManagement.vue?vue&type=style&index=0&id=d0369a9e&prod&lang=css"
import style1 from "./DishesManagement.vue?vue&type=style&index=1&id=d0369a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0369a9e",
  null
  
)

export default component.exports